import { QueryFeature } from '../../../config/queryClient';

enum QueryKey {
  DefaultTemplate = 'DefaultTemplate',
  WidgetTemplate = 'WidgetTemplate',
}

export const queryKeys = {
  defaultTemplate: () => [QueryFeature.PersonalFinanceTemplate, QueryKey.DefaultTemplate],
  widgetTemplate: (templateId: string) => [
    QueryFeature.PersonalFinanceTemplate,
    QueryKey.WidgetTemplate,
    templateId,
  ],
};
